import PropTypes from 'prop-types'

export const bundleSelectionErrorsForCartItem = (errors = [], cartItem) =>
  errors.filter(
    error => error.type === 'bundle_selection_required' && String(error.cart_item_id) === String(cartItem.cart_item_id)
  )

const BundleSelectionErrors = ({ errors, cartItem }) => {
  const cartItemErrors = bundleSelectionErrorsForCartItem(errors, cartItem)

  return cartItemErrors.map(error => (
    <p
      className="small text-danger mf-mb-0 mf-mt-1"
      key={`${error.cart_item_id}-${error.details?.bundle_group_id || error.message}`}
      role="alert"
    >
      {error.message}
    </p>
  ))
}

BundleSelectionErrors.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      cart_item_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      message: PropTypes.string.isRequired
    })
  ),
  cartItem: PropTypes.shape({
    cart_item_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }).isRequired
}

export default BundleSelectionErrors
